module.exports = __webpack_public_path__ + "static/media/UnCheck.253d9d05.svg";